import useCurrentUser from './useCurrentUser';

export default function useDefaultLang() {
    const currentUser = useCurrentUser();
    const browserLanguage = window.navigator.userLanguage || window.navigator.language;

    return localStorage?.language ?? currentUser?.language ?? browserLanguage;
}
